/*
 * @Author: 程序员
 * @Description: 国际化
 * @Date: 2021-07-12 10:44:52
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
import enUS from "vxe-table/lib/locale/lang/en-US";

//自定义翻译部分
import zhLocale from "./zh";
import enLocale from "./en";

Vue.use(VueI18n);

const messages = {
  zh_CN: {
    ...zhLocale,
    ...zhCN,
  },
  en_US: {
    ...enLocale,
    ...enUS,
  },
};
const i18n = new VueI18n({
  locale: "zh_CN",
  messages,
});

export default i18n;
